import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        create: 'Create Label',
        transfer: 'Transfer',
        scan: 'Scan & Update',
        packages: 'Packages',
        inventory: 'Inventory',
        admin: 'Admin',
        logout: 'Logout',
      },
      login: {
        title: 'Sigma Shpërndarje',
        subtitle: 'Shkruani PIN-në për të vazhduar',
        signin: 'Hyr',
        placeholder: 'Skanoni barkod ose shkruani PIN',
        instruction: 'Shkruani PIN-në 6-shifrore ose skanoni barkod',
        signingIn: 'Duke u identifikuar...',
        clear: 'Pastro',
      },
      home: {
        welcome: 'Welcome back, {{name}}',
        choose: 'Choose an action to get started',
        createLabel: 'Create Label',
        createLabelDesc: 'Create a new package and print label',
        transfer: 'Transfer',
        transferDesc: 'Transfer package to new location',
        scanUpdate: 'Scan & Update',
        scanUpdateDesc: 'Scan barcode to update package status',
        packages: 'Packages',
        packagesDesc: 'View and manage packages',
        inventory: 'Inventory',
        inventoryDesc: 'View inventory items',
        admin: 'Admin',
        adminDesc: 'Manage users, packages, products, and audit logs',
      },
      common: {
        close: 'Close',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        update: 'Update',
        search: 'Search',
        filter: 'Filter',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        confirm: 'Confirm',
        yes: 'Yes',
        no: 'No',
        back: 'Back',
        to: 'to',
        list: 'List',
      },
      createLabel: {
        title: 'Create Package Label',
        step1: 'Recipient Information',
        step2: 'Delivery Address',
        step3: 'Select Products',
        step4: 'Review & Create',
        firstName: 'First Name',
        lastName: 'Last Name',
        company: 'Company',
        address: 'Address',
        addressPlaceholder: 'Street address, city, postal code',
        selectProducts: 'Select Products',
        quantity: 'Quantity',
        review: 'Review Package Details',
        packageCode: 'Package Code',
        recipient: 'Recipient',
        items: 'Items',
        printLabel: 'Print Label',
        createPackage: 'Create Package',
        manualEntry: 'Manual Entry',
        importFromExcel: 'Import from Excel',
        excelFormat: 'Excel Format Required:',
        excelColumns: 'Columns:',
        excelProductsNote: 'Products column: SKUs separated by semicolons (e.g.,',
        chooseExcelFile: 'Choose Excel File',
        processingBulkImport: 'Processing bulk import...',
        rowsProcessed: 'of rows processed',
        recipientInfo: 'Recipient Information',
        enterRecipientDetails: 'Enter recipient details',
        nameRequired: 'Name *',
        surnameRequired: 'Surname *',
        firstNamePlaceholder: 'First name',
        lastNamePlaceholder: 'Last name',
        companyPlaceholder: 'Company name',
        addressRequired: 'Address *',
        deliveryAddress: 'Delivery Address',
        enterDeliveryAddress: 'Enter delivery address',
        products: 'Products',
        selectProductsQuantities: 'Select products and quantities',
        selectedProducts: 'Selected Products:',
        available: 'Available:',
        remove: 'Remove',
        noProductsAvailable: 'No products available in inventory',
        labelCreated: 'Label Created!',
        reviewDetailsPrint: 'Review details and print label',
        packageId: 'Package ID:',
        companyLabel: 'Company:',
        addressLabel: 'Address:',
        productsLabel: 'Products:',
        noProducts: 'No products',
        preparingPrint: 'Preparing Print...',
        back: 'Back',
        next: 'Next',
        reviewCreate: 'Review & Create',
        tracking: 'TRACKING',
        scanToTrack: 'SCAN TO TRACK',
        loading: 'Loading...',
        signingIn: 'Signing in...',
        clear: 'Clear',
      },
      packages: {
        title: 'Packages',
        searchPlaceholder: 'Search packages...',
        status: 'Status',
        allStatuses: 'All Statuses',
        created: 'Created',
        printed: 'Printed',
        inTransit: 'In Transit',
        delivered: 'Delivered',
        printLabel: 'Print Label',
        noPackages: 'No packages found',
        packagesManagement: 'Packages Management',
        notes: 'Notes',
        noNotes: 'N/A',
        packageDetails: 'Package Details',
        print: 'Print',
        recipient: 'Recipient',
        deliveryAddress: 'Delivery Address',
        contents: 'Contents',
        packageCode: 'Package Code',
        currentLocation: 'Current Location',
        origin: 'Origin',
        createdAt: 'Created At',
        createdBy: 'Created By',
        tracking: {
          title: 'Package Tracking',
          subtitle: 'Track your package in real-time',
          home: 'Home',
          packageNotFound: 'Package Not Found',
          packageNotFoundDesc: 'The package you are looking for does not exist.',
          goToHome: 'Go to Home',
          loading: 'Loading package information...',
          recipientInfo: 'Recipient Information',
          name: 'Name',
          packageContents: 'Package Contents',
          packageDetails: 'Package Details',
          statusHistory: 'Status History',
        },
      },
      inventory: {
        title: 'Inventory',
        product: 'Product',
        stock: 'Stock',
        minThreshold: 'Min Threshold',
        noItems: 'No inventory items',
        inventoryManagement: 'Inventory Management',
        noProductsFound: 'No products found',
        unit: 'Unit',
        lowStock: '⚠️ Low Stock',
        selected: 'Selected:',
        sku: 'SKU',
        stockLabel: 'Stock:',
      },
      admin: {
        title: 'Admin Panel',
        users: 'Users',
        products: 'Products',
        packages: 'Packages',
        auditLog: 'Audit Log',
        userManagement: 'User Management',
        addUser: '+ Add User',
        addUserButton: 'Add User',
        fullName: 'Full name',
        pinLabel: 'PIN',
        pinPlaceholder: '6-digit PIN',
        role: 'Role',
        standard: 'Standard',
        adminRole: 'Admin',
        packageManagement: 'Package Management',
        viewModifyPackage: 'View and modify package details, status, and information',
        searchPackages: 'Search packages by ID, contents, or creator...',
        editPackage: 'Edit Package:',
        statusLabel: 'Status',
        currentLocation: 'Current Location',
        currentLocationPlaceholder: 'e.g., Main Office, Warehouse',
        destinationBranch: 'Destination Branch',
        selectBranch: 'Select branch',
        contentsProducts: 'Contents / Products',
        contentsPlaceholder: 'List products and quantities (e.g., Electronics x2, Documents x1)',
        saveChanges: 'Save Changes',
        noAuditLogs: 'No audit logs found',
        action: 'ACTION',
        entity: 'ENTITY',
        user: 'User:',
        unknownUser: 'Unknown User',
        entityId: 'Entity ID:',
        timestamp: 'Timestamp:',
        ipAddress: 'IP Address:',
        viewChanges: 'View Changes',
        before: 'Before:',
        after: 'After:',
        deletePackage: 'Delete Package',
        deleteConfirmMessage: 'Are you sure you want to delete package {{code}}? This action cannot be undone and will also delete all related history and scans.',
        deleteButton: 'Delete',
        accessDenied: 'Access Denied',
        onlyAdminAccess: 'Only administrators can access this section.',
      },
      scanner: {
        title: 'Scan Barcode',
        close: 'Close',
        reset: 'Reset',
        flash: 'Flash',
        flashOff: 'Flash Off',
        flashUnavailable: 'Flash Unavailable',
        scanning: 'Scanning...',
        stopped: 'Stopped',
        initializing: 'Initializing...',
        error: 'Error',
        startingCamera: 'Starting Camera...',
        allowCameraAccess: 'Please allow camera access',
        cameraError: 'Camera Error',
        tryAgain: 'Try Again',
        startScanning: 'Start Scanning',
        positionBarcode: 'Position barcode within the frame',
        supportsFormats: 'Supports Code 128 and QR codes',
        holdDistance: 'Hold device 30-100cm from barcode for best results',
        scans: 'Scans',
        packageDetails: 'Package Details',
        viewUpdateInfo: 'View and update package information',
        packageCode: 'Package Code',
        currentStatus: 'Current Status',
        recipientInformation: 'Recipient Information',
        name: 'Name',
        company: 'Company',
        address: 'Address',
        packageContents: 'Package Contents',
        items: 'items',
        item: 'item',
        lastEvent: 'Last Event',
        updatedBy: 'Updated by',
        packageInformation: 'Package Information',
        itemCount: 'Item Count',
        destination: 'Destination',
        origin: 'Origin',
        currentLocation: 'Current Location',
        createdBy: 'Created By',
        createdAt: 'Created At',
        statusHistory: 'Status History',
        contentsNote: 'Contents Note',
        updateStatus: 'Update Status',
        selectNewStatus: 'Select New Status',
        optionalNote: 'Optional Note',
        notePlaceholder: 'Add a note about this status update (optional)...',
        confirmSave: 'Confirm & Save',
        saving: 'Saving...',
        packageNotFound: 'Package Not Found',
        scannedCode: 'Scanned code',
        backToScanner: 'Back to Scanner',
        copyCode: 'Copy Code',
        loadingPackage: 'Loading Package...',
        fetchingDetails: 'Fetching package details',
        packageFound: 'Package {{code}} found! Opening details...',
        packageUpdated: 'Package {{code}} updated successfully',
        statusUpdated: 'Status updated',
        errorProcessing: 'Error processing scan. Please try again.',
        errorUpdating: 'Error updating status',
        selectStatus: 'Please select a status',
        cameraPermissionDenied: 'Camera permission denied. Please allow camera access in your browser settings and refresh the page.',
        cameraPermissionDeniedMobile: 'Camera permission denied. Please:\n1. Tap the address bar\n2. Tap the camera icon\n3. Allow camera access\n4. Refresh the page',
        noCameraFound: 'No camera found. Please ensure your device has a camera enabled.',
        cameraInUse: 'Camera is being used by another application. Please close other apps using the camera.',
        cameraRequiresHTTPS: 'Camera requires HTTPS connection. Please access the site via HTTPS.',
        cameraRequiresHTTPSMobile: 'Camera requires HTTPS connection. Mobile browsers need a secure connection. Please access via HTTPS or use localhost.',
        cameraTimeout: 'Camera access timed out. Please check your browser permissions and try again.',
        cameraIOSFailed: 'Camera access failed on iOS. Please ensure you granted camera permission and try again.',
        scannerNotFound: 'Scanner container not found. Please refresh the page.',
        statuses: {
          just_created: 'Just Created',
          created: 'Created',
          envelope_prepared: 'Envelope Prepared',
          queued_for_print: 'Queued for Print',
          printed: 'Printed',
          handed_over: 'Handed Over',
          in_transit: 'In Transit',
          at_branch: 'At Branch',
          delivered: 'Delivered',
          returned: 'Returned',
          canceled: 'Canceled',
        },
        singleScan: 'Single Scan',
        bulkUpdate: 'Bulk Update',
        selectStatusForBulk: 'Select Status for Bulk Update',
        selectStatusFirst: 'Select status first',
        scanToUpdate: 'Scan packages to update them to',
        updated: 'Updated',
      },
    }
  },
  al: {
    translation: {
      nav: {
        home: 'Kreu',
        create: 'Krijo Etiketë',
        transfer: 'Transferimi',
        scan: 'Skanoni & Përditësoni',
        packages: 'Paketat',
        inventory: 'Inventari',
        admin: 'Admin',
        logout: 'Dil',
      },
      login: {
        title: 'Sigma Shpërndarje',
        subtitle: 'Shkruani PIN-në për të vazhduar',
        signin: 'Hyr',
        placeholder: 'Skanoni barkod ose shkruani PIN',
        instruction: 'Shkruani PIN-në 6-shifrore ose skanoni barkod',
        signingIn: 'Duke u identifikuar...',
        clear: 'Pastro',
      },
      home: {
        welcome: 'Mirë se u ktheve, {{name}}',
        choose: 'Zgjidh një veprim për të filluar',
        createLabel: 'Krijo Etiketë',
        createLabelDesc: 'Krijo një paketë të re dhe printo etiketën',
        transfer: 'Transferimi',
        transferDesc: 'Transfero paketën në vendndodhje të re',
        scanUpdate: 'Skanoni & Përditësoni',
        scanUpdateDesc: 'Skanoni barkodin për të përditësuar statusin e paketës',
        packages: 'Paketat',
        packagesDesc: 'Shiko dhe menaxho paketat',
        inventory: 'Inventari',
        inventoryDesc: 'Shiko artikujt e inventarit',
        admin: 'Admin',
        adminDesc: 'Menaxho përdoruesit, paketat, produktet dhe regjistrat e aktivitetit',
      },
      common: {
        close: 'Mbyll',
        save: 'Ruaj',
        cancel: 'Anulo',
        delete: 'Fshi',
        edit: 'Modifiko',
        create: 'Krijo',
        update: 'Përditëso',
        search: 'Kërko',
        filter: 'Filtro',
        loading: 'Duke u ngarkuar...',
        error: 'Gabim',
        success: 'Sukses',
        confirm: 'Konfirmo',
        yes: 'Po',
        no: 'Jo',
        back: 'Kthehu',
        to: 'te',
        list: 'Lista',
      },
      createLabel: {
        title: 'Krijo Etiketë Pakete',
        step1: 'Informacioni i Marrësit',
        step2: 'Adresa e Dorëzimit',
        step3: 'Zgjidh Produktet',
        step4: 'Rishiko & Krijo',
        firstName: 'Emri',
        lastName: 'Mbiemri',
        company: 'Kompania',
        address: 'Adresa',
        addressPlaceholder: 'Adresa e rrugës, qyteti, kodi postar',
        selectProducts: 'Zgjidh Produktet',
        quantity: 'Sasia',
        review: 'Rishiko Detajet e Paketës',
        packageCode: 'Kodi i Paketës',
        recipient: 'Marrësi',
        items: 'Artikuj',
        printLabel: 'Printo Etiketën',
        createPackage: 'Krijo Paketën',
        manualEntry: 'Hyrje Manuale',
        importFromExcel: 'Importo nga Excel',
        excelFormat: 'Formati i Excel i Kërkuar:',
        excelColumns: 'Kolonat:',
        excelProductsNote: 'Kolona e Produkteve: SKU-të të ndara me pikëpresje (p.sh.,',
        chooseExcelFile: 'Zgjidh Skedarin Excel',
        processingBulkImport: 'Duke përpunuar importin në masë...',
        rowsProcessed: 'nga rreshtat e përpunuar',
        recipientInfo: 'Informacioni i Marrësit',
        enterRecipientDetails: 'Shkruani detajet e marrësit',
        nameRequired: 'Emri *',
        surnameRequired: 'Mbiemri *',
        firstNamePlaceholder: 'Emri',
        lastNamePlaceholder: 'Mbiemri',
        companyPlaceholder: 'Emri i kompanisë',
        addressRequired: 'Adresa *',
        deliveryAddress: 'Adresa e Dorëzimit',
        enterDeliveryAddress: 'Shkruani adresën e dorëzimit',
        products: 'Produktet',
        selectProductsQuantities: 'Zgjidhni produktet dhe sasitë',
        selectedProducts: 'Produktet e Zgjedhura:',
        available: 'Në dispozicion:',
        remove: 'Hiq',
        noProductsAvailable: 'Nuk ka produkte në dispozicion në inventar',
        labelCreated: 'Etiketa u Kriua!',
        reviewDetailsPrint: 'Rishikoni detajet dhe printoni etiketën',
        packageId: 'ID e Paketës:',
        companyLabel: 'Kompania:',
        addressLabel: 'Adresa:',
        productsLabel: 'Produktet:',
        noProducts: 'Nuk ka produkte',
        preparingPrint: 'Duke përgatitur për printim...',
        back: 'Kthehu',
        next: 'Tjetra',
        reviewCreate: 'Rishiko & Krijo',
        tracking: 'NDJETIMI',
        scanToTrack: 'SKANO PËR TË NDJETUR',
        loading: 'Duke u ngarkuar...',
        signingIn: 'Duke u identifikuar...',
        clear: 'Pastro',
      },
      packages: {
        title: 'Paketat',
        searchPlaceholder: 'Kërko paketa...',
        status: 'Statusi',
        allStatuses: 'Të Gjitha Statuset',
        created: 'Krijuar',
        printed: 'E printuar',
        inTransit: 'Në Transit',
        delivered: 'Dorëzuar',
        printLabel: 'Printo Etiketën',
        noPackages: 'Nuk u gjetën paketa',
        packagesManagement: 'Menaxhimi i Paketave',
        notes: 'Shënime',
        noNotes: 'N/A',
        packageDetails: 'Detajet e Paketës',
        print: 'Printo',
        recipient: 'Marrësi',
        deliveryAddress: 'Adresa e Dorëzimit',
        contents: 'Përmbajtja',
        packageCode: 'Kodi i Paketës',
        currentLocation: 'Vendndodhja Aktuale',
        origin: 'Origjina',
        createdAt: 'Krijuar Më',
        createdBy: 'Krijuar Nga',
        tracking: {
          title: 'Ndjekja e Paketës',
          subtitle: 'Ndjekni paketën tuaj në kohë reale',
          home: 'Kreu',
          packageNotFound: 'Paketa nuk u gjet',
          packageNotFoundDesc: 'Paketa që po kërkoni nuk ekziston.',
          goToHome: 'Shko në Kreu',
          loading: 'Duke ngarkuar informacionin e paketës...',
          recipientInfo: 'Informacioni i Marrësit',
          name: 'Emri',
          packageContents: 'Përmbajtja e Paketës',
          packageDetails: 'Detajet e Paketës',
          statusHistory: 'Historia e Statusit',
        },
      },
      inventory: {
        title: 'Inventari',
        product: 'Produkti',
        stock: 'Stoku',
        minThreshold: 'Pragu Minimal',
        noItems: 'Nuk ka artikuj në inventar',
        inventoryManagement: 'Menaxhimi i Inventarit',
        noProductsFound: 'Nuk u gjetën produkte',
        unit: 'Njësia',
        lowStock: '⚠️ Stok i Ulët',
        selected: 'E zgjedhur:',
        sku: 'SKU',
        stockLabel: 'Stoku:',
      },
      admin: {
        title: 'Paneli i Administratorit',
        users: 'Përdoruesit',
        products: 'Produktet',
        packages: 'Paketat',
        auditLog: 'Regjistri i Aktivitetit',
        userManagement: 'Menaxhimi i Përdoruesve',
        addUser: '+ Shto Përdorues',
        addUserButton: 'Shto Përdorues',
        fullName: 'Emri i plotë',
        pinLabel: 'PIN',
        pinPlaceholder: 'PIN 6-shifror',
        role: 'Roli',
        standard: 'Standard',
        adminRole: 'Admin',
        packageManagement: 'Menaxhimi i Paketave',
        viewModifyPackage: 'Shiko dhe modifiko detajet, statusin dhe informacionin e paketës',
        searchPackages: 'Kërko paketa sipas ID, përmbajtjes ose krijuesit...',
        editPackage: 'Modifiko Paketën:',
        statusLabel: 'Statusi',
        currentLocation: 'Vendndodhja Aktuale',
        currentLocationPlaceholder: 'p.sh., Zyra Kryesore, Depo',
        destinationBranch: 'Degë Destinacioni',
        selectBranch: 'Zgjidh degën',
        contentsProducts: 'Përmbajtja / Produktet',
        contentsPlaceholder: 'Listo produktet dhe sasitë (p.sh., Elektronika x2, Dokumente x1)',
        saveChanges: 'Ruaj Ndryshimet',
        noAuditLogs: 'Nuk u gjetën regjistra aktiviteti',
        action: 'VEPRIMI',
        entity: 'ENTITETI',
        user: 'Përdoruesi:',
        unknownUser: 'Përdorues i Panjohur',
        entityId: 'ID e Entitetit:',
        timestamp: 'Koha:',
        ipAddress: 'Adresa IP:',
        viewChanges: 'Shiko Ndryshimet',
        before: 'Para:',
        after: 'Pas:',
        deletePackage: 'Fshi Paketën',
        deleteConfirmMessage: 'Jeni të sigurt që dëshironi të fshini paketën {{code}}? Ky veprim nuk mund të zhbëhet dhe do të fshijë gjithashtu të gjithë historinë dhe skanimet e lidhura.',
        deleteButton: 'Fshi',
        accessDenied: 'Qasja e Refuzuar',
        onlyAdminAccess: 'Vetëm administratorët mund të hyjnë në këtë seksion.',
      },
      scanner: {
        title: 'Skanoni Barkod',
        close: 'Mbyll',
        reset: 'Rivendos',
        flash: 'Drita',
        flashOff: 'Fik Dritën',
        flashUnavailable: 'Drita nuk është e disponueshme',
        scanning: 'Duke skanuar...',
        stopped: 'U ndal',
        initializing: 'Duke inicializuar...',
        error: 'Gabim',
        startingCamera: 'Duke filluar kamerën...',
        allowCameraAccess: 'Ju lutemi lejoni aksesin në kamerë',
        cameraError: 'Gabim në Kamerë',
        tryAgain: 'Provo Përsëri',
        startScanning: 'Fillo Skanimin',
        positionBarcode: 'Vendosni barkodin brenda kornizës',
        supportsFormats: 'Mbulon Code 128 dhe QR kodet',
        holdDistance: 'Mbajeni pajisjen 30-100cm nga barkodi për rezultate më të mira',
        scans: 'Skanime',
        packageDetails: 'Detajet e Paketës',
        viewUpdateInfo: 'Shiko dhe përditëso informacionin e paketës',
        packageCode: 'Kodi i Paketës',
        currentStatus: 'Statusi Aktual',
        recipientInformation: 'Informacioni i Marrësit',
        name: 'Emri',
        company: 'Kompania',
        address: 'Adresa',
        packageContents: 'Përmbajtja e Paketës',
        items: 'artikuj',
        item: 'artikull',
        lastEvent: 'Eventi i Fundit',
        updatedBy: 'Përditësuar nga',
        packageInformation: 'Informacioni i Paketës',
        itemCount: 'Numri i Artikujve',
        destination: 'Destinacioni',
        origin: 'Origjina',
        currentLocation: 'Vendndodhja Aktuale',
        createdBy: 'Krijuar nga',
        createdAt: 'Krijuar më',
        statusHistory: 'Historia e Statusit',
        contentsNote: 'Shënim i Përmbajtjes',
        updateStatus: 'Përditëso Statusin',
        selectNewStatus: 'Zgjidh Statusin e Ri',
        optionalNote: 'Shënim Opsional',
        notePlaceholder: 'Shto një shënim për këtë përditësim statusi (opsional)...',
        confirmSave: 'Konfirmo & Ruaj',
        saving: 'Duke ruajtur...',
        packageNotFound: 'Paketa nuk u gjet',
        scannedCode: 'Kodi i skanuar',
        backToScanner: 'Kthehu te Skanuesi',
        copyCode: 'Kopjo Kodin',
        loadingPackage: 'Duke ngarkuar paketën...',
        fetchingDetails: 'Duke marrë detajet e paketës',
        packageFound: 'Paketa {{code}} u gjet! Po hapet...',
        packageUpdated: 'Paketa {{code}} u përditësua me sukses',
        statusUpdated: 'Statusi u përditësua',
        errorProcessing: 'Gabim në përpunimin e skanimit. Ju lutemi provoni përsëri.',
        errorUpdating: 'Gabim në përditësimin e statusit',
        selectStatus: 'Ju lutemi zgjidhni një status',
        cameraPermissionDenied: 'Leja për kamerë u refuzua. Ju lutemi lejoni aksesin në kamerë në cilësimet e shfletuesit dhe rifreskoni faqen.',
        cameraPermissionDeniedMobile: 'Leja për kamerë u refuzua. Ju lutemi:\n1. Prekni shiritin e adresës\n2. Prekni ikonën e kamerës\n3. Lejoni aksesin në kamerë\n4. Rifreskoni faqen',
        noCameraFound: 'Kamera nuk u gjet. Ju lutemi sigurohuni që pajisja juaj ka kamerë të aktivizuar.',
        cameraInUse: 'Kamera po përdoret nga një aplikacion tjetër. Ju lutemi mbyllni aplikacionet e tjera që përdorin kamerën.',
        cameraRequiresHTTPS: 'Kamera kërkon lidhje HTTPS. Ju lutemi hyni në faqe përmes HTTPS.',
        cameraRequiresHTTPSMobile: 'Kamera kërkon lidhje HTTPS. Shfletuesit mobilë kanë nevojë për një lidhje të sigurt. Ju lutemi hyni përmes HTTPS ose përdorni localhost.',
        cameraTimeout: 'Aksesi në kamerë u ndal nga koha. Ju lutemi kontrolloni lejet e shfletuesit dhe provoni përsëri.',
        cameraIOSFailed: 'Aksesi në kamerë dështoi në iOS. Ju lutemi sigurohuni që keni dhënë leje për kamerë dhe provoni përsëri.',
        scannerNotFound: 'Kontenieri i skanuesit nuk u gjet. Ju lutemi rifreskoni faqen.',
        statuses: {
          just_created: 'Sapo Krijuar',
          created: 'Pakoja eshte pergatitur',
          envelope_prepared: 'Zarfi pergatitur',
          queued_for_print: 'Gati per dergese',
          printed: 'Gati per dergese',
          handed_over: 'Per dergese nga personi kontaktit',
          in_transit: 'Ne Tranzit',
          at_branch: 'Në Degë',
          delivered: 'Dorezuar',
          returned: 'Kthyer',
          canceled: 'Do dergohet me vone',
        },
        singleScan: 'Skanim i Vetëm',
        bulkUpdate: 'Përditësim në Masë',
        selectStatusForBulk: 'Zgjidhni Statusin për Përditësim në Masë',
        selectStatusFirst: 'Zgjidhni statusin fillimisht',
        scanToUpdate: 'Skanoni paketat për t\'i përditësuar në',
        updated: 'Përditësuar',
      },
    }
  }
};

const lng = localStorage.getItem('sigma-lang') || 'al';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng,
    fallbackLng: 'al',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
